import React from "react";

const Card = ({ image, title, info, URL }) => {
  return (
    <div className="portfolio-item">
      <div className="item-wrap">
        <a href={URL}>
          <img alt="" src={image} />
          <div className="overlay" />
          <div className="link-icon">
            <i className="fa fa-link" />
          </div>
        </a>
        <div className="portfolio-item-meta">
          <h5>
            <a href={URL}> {title} </a>
          </h5>
          <p>{info}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
